import React from 'react';
import dayjs from 'dayjs';
import Icon from '../common/Icon';
import { exportDeliveries, deleteDelivery } from './constants/handleDeliveries';

var calendar = require('dayjs/plugin/calendar');
dayjs.extend(calendar);

const SubmissionDeliveries = ({
  deliveries,
  setDeliveries,
  user,
  handleMailerButton,
  subID,
}) => {
  const handleExportDeliveries = () => {
    exportDeliveries(deliveries, subID);
  };

  const handleDeleteDelivery = async (id) => {
    await deleteDelivery(id, (response) => {
      if (response.ok) setDeliveries([...deliveries.filter((d) => d.id != id)]);
    });
  };

  return (
    <section className='deliveries'>
      <h2>Deliveries</h2>

      <div className='controls'>
        {user.canWrite && (
          <Icon
            title='Single Mailer'
            icon='envelope'
            onClick={handleMailerButton}
          />
        )}
        <Icon
          title='Export Deliveries'
          icon='download'
          onClick={(e) => handleExportDeliveries()}
        />
      </div>

      <table>
        <thead>
          <tr>
            <th>Sent To</th>
            <th className='small'>BCC</th>
            <th>Mailer Name</th>
            <th className='small'>Sent By</th>
            <th className='small'>Date Sent</th>
          </tr>
        </thead>
        <tbody>
          {deliveries.length ? (
            deliveries.map((delivery) => {
              return (
                <tr
                  className={delivery.mailed_at ? '' : 'unsent'}
                  key={delivery.id}
                >
                  <td>{delivery.to}</td>
                  <td>{delivery.bcc}</td>
                  <td>{delivery.mailer_name}</td>
                  <td>{delivery.sent_by}</td>
                  <td className='flex'>
                    {delivery.mailed_at && (
                      <time dateTime={delivery.mailed_at}>
                        {dayjs(delivery.mailed_at).calendar()}
                      </time>
                    )}
                    {user.canWrite && (
                      <Icon
                        title='Delete'
                        icon='trash'
                        className='right'
                        onClick={() => handleDeleteDelivery(delivery.id)}
                      />
                    )}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr className='empty'>
              <td colSpan='100%'>
                There are no deliveries for this submission.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </section>
  );
};

export default SubmissionDeliveries;
